import React, { useContext } from 'react'
import { UserIndexContext } from '../../../../context/security/UserIndexProvider';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faFloppyDisk,
    faSquarePlus,
    faEye,
    faEyeSlash,
} from "@fortawesome/free-solid-svg-icons";
import './createUser.css';

export const CreateUser = () => {
    const [{ createEditUserItemFormState, for_Edit, for_View_Pass }, { setFieldFormUser, setfor_View_Pass, createUserClick, editUserClick }] = useContext(UserIndexContext);
    return (
        <div>
            <div className="row">

                <div className="mb-3 col-md-4">
                    <label className="form-label">Nombres y apellidos</label>
                    <input value={createEditUserItemFormState.name} type="text" className="form-control" id="exampleInputText" onChange={(e) => setFieldFormUser(e.target.value, "name")} />
                </div>

                <div className="mb-3 col-md-3">
                    <label className="form-label">Correo electrónico</label>
                    <input value={createEditUserItemFormState.email} type="email" className="form-control" id="exampleInputText" onChange={(e) => setFieldFormUser(e.target.value, "email")} />
                </div>

                <div className="mb-3 col-md-2 ">
                    <label className="form-label">Contraseña</label>
                    <div className='container-password-users' >
                        <input value={createEditUserItemFormState.password} type={for_View_Pass ? "text" : "password"} className="form-control" id="exampleInputText" onChange={(e) => setFieldFormUser(e.target.value, "password")} />

                        <FontAwesomeIcon
                            onClick={() => setfor_View_Pass(!for_View_Pass)}
                            className="cursor-pointer"
                            icon={for_View_Pass ? faEyeSlash : faEye}
                        />
                    </div>
                </div>

                <div className="div-for-btn-warehouse">
                    <div
                        onClick={() => {
                            for_Edit ? editUserClick() : createUserClick()
                        }}
                        className="flex btn-default button-form-warehouse"
                    >
                        <FontAwesomeIcon
                            className="margin-auto"
                            icon={for_Edit ? faFloppyDisk : faSquarePlus}
                        />
                        &nbsp;
                        <span> {for_Edit ? "Guardar" : "Crear"} </span>
                    </div>
                </div>


            </div>
        </div>
    )
}
